module.exports = __webpack_public_path__ + "static/media/icon-6.fe12173b.png";